import React, {Component} from 'react'
import { withApollo } from 'react-apollo'
import { Queries, Mutations } from '../../../../graphql'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Tabs, Typography, Spin, Row, Col, Input, message, Table, Icon, Button, Popconfirm, Form, Select, DatePicker, Avatar} from 'antd'
import Container from '../../../../components/user/Container'
import FromInput from '../../../../components/user/from/Input'
import InputDateStartEnd from '../../../../components/user/from/Input'
import { checkType } from '../../../../utils/checkType'
import { numberWithCommas } from '../../../../utils/number'
import { changeFormatdate } from '../../../../utils/formatdate'
import { checkStatus } from '../../../../utils/hospital'
import { alertMessage } from '../../../../utils/message'

import moment from 'moment'

const { TabPane } = Tabs
const { Text, Title } = Typography
const { Option } = Select;

const newsDataProfile = '';

class SearchForm extends Component {

	state = {
		loading:true,
		dataTalbe: [],
        columns: [
			{
                title: 'เลขที่สารบรรณ',
                dataIndex: 'refDocument',
                width:'125px',
				align:'center',
                render: (item, record, index) => <div style={{ width:"90px", wordWrap:"break-word" }}><span>{ item }</span></div>
            },
            {
                title: 'เลขที่เอกสาร',
                dataIndex: 'withdrawNo',
                width:'90px',
				   align:'center',
                // render: (item, record, index) => <span>{ (this.state.pageData.offset+index) + 1}</span>
                render: (item, record, index) => <span>{ item }</span>
            },
			{
                title: 'ชื่อบุคลากร',
                dataIndex: 'empFirstName',
				align:"center",
                width:'200px',
				render: (item, record, index) => <span>{record.empFirstName+' '+record.empLastName}</span>
            },
			{
                title: 'ชื่อผู้เบิก',
				align:"center",
                dataIndex: 'withdrawFirstName',
                width:'200px',
				render: (item, record, index) => <span>{record.withdrawFirstName+' '+record.withdrawLastName}</span>
            },
			{
                title: 'ป่วยเป็นโรค',
                dataIndex: 'sicknessName',
				align:"center",
                width:'200px',
				render: (item, record, index) => <span>{ item }</span>
            },
			{
                title: 'จำนวนเงินในใบเสร็จ',
				align:'center',
                width:'100px',
                dataIndex: 'totalWithdraw',
                render: (item, record, index) => <div  align="right"><span>{ item ? numberWithCommas(item) : '' }</span></div>
            },
			{
                title: 'จำนวนเงินที่เบิกได้ทั้งหมด',
				align:'center',
                dataIndex: 'totalCurrentWithdraw',
                width:'100px',
                render: (item, record, index) => <div align="right"><span>{item ? numberWithCommas(item) : 0}</span></div>
            },
			{
                title: 'วันที่ยื่นเรื่อง',
				align:'center',
                width:'150px',
                dataIndex: 'date',
                render: (item, record, index) => <span>{changeFormatdate(item)}</span>
            },
			{
                title: 'วันที่สร้างเอกสาร',
				align:'center',
                width:'150px',
                dataIndex: 'createdAt',
                render: (item, record, index) => <span>{changeFormatdate(item)}</span>
            },
			{
                title: 'วันที่จ่ายเงิน',
				align:'center',
                width:'150px',
                dataIndex: 'exportPayDate',
                render: (item, record, index) => <span>{ item ? changeFormatdate(item) : '-'}</span>
            },
			{
                title: 'สถานะ',
				align:'center',
                width:'150px',
                dataIndex: 'status',
                render: (item, record, index) => <span>{ checkStatus(item)}</span>
            },
            {
                title: 'รายละเอียด',
                dataIndex: '7',
                width:'120px',
				align:'center',
				// fixed: 'right',
                render: (item, record, index) => {
                    return <>
								<Link
									to={{
										pathname: '/hospital/Withdraw/'+record.wdHospitalId
									}}
								>
									{/* <Icon type="form" className="mr-2" style={{ color:"#000" }}/> */}
									{/* <Button */}
									{/* <Avatar shape="square" size={24} icon="eye"  style={{ color:"#000" }}/> */}
									<Icon type="eye" className="mr-2" style={{ color:"#000" }}/>
								</Link>
								{/* {
									record.status == 'DRAFT' &&
									<Popconfirm placement="topRight" title={"คุณต้องการที่จะลบ"} onConfirm={ () => this.delectField(record.wdHospitalId)} okText="ตกลง" cancelText="ยกเลิก">
										<Icon type="delete"/>
									</Popconfirm>
								} */}
							</>
                }
            },
        ],
		pageData: {
            offset: 0,
            limit: 10
        },
        pagination: {
            total: 10,
        },
        disabledDateStart:moment().add(-30, 'days'),
		endStartValues:moment(),
		valueStatus:"ALL",
		preLoadSubmit:true,
		formValue:null
	}

	fetchListWDHospital = async()=>{
		const { client,location ,match } = this.props
        const { offset ,limit, disabledDateStart, endStartValues } = this.state

        await this.setState({
            preLoadSubmit:true,
			loading:true
        })

        const { data, errors } = await client.query({
            query: Queries.fetchListSearchWDHospital,
			variables: {
				// startDate: disabledDateStart,
				// endDate: endStartValues,
				status: "ALL",
				searchType: 'DETAIL'
			}
        })


		console.log('datasssss',data.fetchListWDHospital)

		if(data.fetchListWDHospital){
			await this.setState({
				dataTalbe: data.fetchListWDHospital,
				loading:false,
				preLoadSubmit:false,
			})
		}else{
			await this.setState({
				loading:false,
				preLoadSubmit:false,
				dataTalbe:[]
			})
		}
	}

	handleSubmit = async (e) => {
        const { form, afterSubmit, client } = this.props
        const { telNo, otpToken, refCode } = this.state
		await e.preventDefault()
		await this.setState({
			loading: true
		})
		form.validateFields(async (err, values) => {
			console.log('values',values)
			await this.setState({
				formValue: e
			})

			// await this.searchListWdHospital(values)
			if (!err) {
                try {
					const { data, errors } = await client.query({
						query: Queries.fetchListSearchWDHospital,
                        variables: {
                            ...values,
							searchType: 'DETAIL'
                        }
					})
					
                    if(data.fetchListWDHospital){
						await this.setState({
							dataTalbe: data.fetchListWDHospital,
							loading: false
						})
					}else{
						await this.setState({
							dataTalbe: [],
							loading: false
						})
					}
                }catch (error) {
					console.log('error',error)
                }
			}
		})
	}
	
	delectField = async(wdHospitalId) =>{
		const { form, client } = this.props
		const { formValue } = this.state
		console.log(formValue)
		try {
			const { data, errors } = await client.mutate({
				mutation: Mutations.destroyWDHospital,
				variables: {
					wdHospitalId
				}
			})
			// console.log(data)
			if(data){
				alertMessage("success","ทำการลบรายการขอเบิก")
				// message.success("ทำการลบรายการขอเบิก")
				if(formValue){
					await this.handleSubmit(formValue)
					// await this.searchListWdHospital(formValue)
				}else{
					this.fetchListWDHospital()
				}
			}
			
		}catch (error) {
			this.setState({
				preLoadOnsubmit: false
			})
			console.log('error',error)
		}
	}

	paginationChange = async e => {
        let offset = 0;
        if (e.current === 1) {
            offset = 0
        } else {
            offset = e.current - 1 + "0"
        }

        await this.setState({
            pageData: {
                offset: parseInt(offset),
                limit: 10
            }
        })

        // this.fetchListPost()
    }

	clearInput = async () =>{
		await this.setState({
			formValue:null,
			disabledDateStart:moment().add(-30, 'days'),
			endStartValues:moment(),
		})
		this.props.form.resetFields();
	}

	onChangeValueDateStart = async (e) =>{

		// this.form.resetFields('endDate')
		await this.setState({
			 disabledDateStart: moment(e),
		})

		await this.props.form.setFieldsValue({
			endStartValues: '',
		})
	 }

	onChangeValueDateEnd = async (e) =>{
		await this.setState({
			endStartValues: moment(e),
		})
	}

	onChangeStatus = async (e) =>{
		// this.form.resetFields('endDate')
		// await this.setState({
		// 	 disabledDateStart: moment(e),
		// })
	}
 
	disabledDate = (current) =>{
		 const { disabledDateStart } = this.state
		 return current && current < disabledDateStart;
	}

	async componentDidMount(){
		await this.fetchListWDHospital()
    }

	render() {
		const { match } = this.props
		const { dataTalbe, columns, loading, pagination, valuesEndDate, disabledDateStart, endStartValues, preLoadSubmit} = this.state
		const { getFieldDecorator } = this.props.form;
		console.log('sssdataTalbe',dataTalbe)
		return (
			<Container match={match}>
				 <div className="breadcrumb-custom pb-3 mb-5">
                    {/* <Breadcrumb.Item> */}
                        <span style={{ fontSize:"18px" }}>การเบิกค่ารักษาพยาบาล / รายการเบิกทั้งหมด </span>
                    {/* </Breadcrumb.Item> */}
                </div>
				<div className="card-container" id="page-profile">
					<div className="px-5 py-1 card-bg-green">
						<Form onSubmit={this.handleSubmit}>
							<Row gutter={16} type="flex" justify="left" align="top" className="box-color-white" >
								<Col xs={24} md={24} className="pt-2 mb-4">
									<strong className="color-red">
										ค้นหา
									</strong>
								</Col>
								
								{/* <Col xs={ 24 } md={8}>
									<Form.Item label="วันที่ขอเบิก" className="mb-0">
										{ getFieldDecorator('startDate', {
											initialValue: disabledDateStart,
											rules:  [{ 
												required:false,
												message: 'กรุณากรอกหรือเลือก วันที่ขอเบิก',
											}],
										})(
											<DatePicker 
												className="w-100"  
												placeholder="เลือกวันที่" 
												onChange={(e) => this.onChangeValueDateStart(e)}
												allowClear={false}
											/>
										)}
									</Form.Item>
								</Col>
								
								<Col xs={ 24 } md={8}>
									<Form.Item label="วันที่สิ้นสุดขอเบิก" className="mb-0">
										{ getFieldDecorator('endDate', {
											initialValue: endStartValues,
											rules:  [{ 
												required:false,
												message: 'กรุณากรอกหรือเลือก วันที่สิ้นสุดขอเบิก',
											}],
										})(
											<DatePicker 
												disabledDate={this.disabledDate} 
												disabled={ disabledDateStart ? false : true }
												className="w-100" 
												// defaultValue={ valuesEndDate ? moment(valuesEndDate) : '' } 
												placeholder="เลือกวันที่"
												onChange={(e) => this.onChangeValueDateEnd(e)}
												allowClear={false}
											/>
										)}
									</Form.Item>
								</Col> */}
								
								<Col xs={24} md={12}>
                                    <Form.Item label={"ค้นหา"}>
                                        { getFieldDecorator("searchKeyword", {
                                            initialValue: '',
                                            rules:  [{ 
                                                required:false, 
                                            }],
                                        })(
                                            <Input 
                                                className='block-news' 
                                            />
                                        )}
                                    </Form.Item>
                                </Col>


								<Col xs={ 24 } md={12} >
									<Form.Item label={"สถานะ"}>
										{ getFieldDecorator("status", {
											initialValue: "ALL",
											rules:  [{ 
												message: 'กรุณากรอกหรือเลือก สถานะ',
											}],
										})(
											<Select style={{ width: "100%" }} onChange={(e) => this.onChangeStatus(e)}>
												<Option value="ALL">ทั้งหมด</Option>
												<Option value="APPROVE">อนุมัติ</Option>
												<Option value="PENDING">รออนุมัติ</Option>
												<Option value="REJECT">ไม่อนุมัติ</Option>
												<Option value="MOREINFO">ขอเอกสารเพิ่มเติม</Option>
												<Option value="PAID">รอโอนเงิน</Option>
												<Option value="SUCCESS">ดำเนินการเสร็จสิ้น</Option>
												<Option value="EDIT">แก้ไข</Option>
												<Option value="FAILED">โอนเงินไม่สำเร็จ (รอจ่ายเงินสด)</Option>
												<Option value="DRAFT">แบบร่าง</Option>
												<Option value="CANCEL">คืนเงินให้คลัง</Option>
												<Option value="CASH">จ่ายเงินสด</Option>
												<Option value="CANCELDOC">ยกเลิกเอกสาร</Option>
												<Option value="PAIDCASH">รับเป็นเงินสด</Option>
											</Select>
										)}
									</Form.Item>
								</Col>

								<Col xs={24} md={24} align={"right"}>
									{/* <Button type="primary" className="mx-2 btn-white-red" htmlType="submit" onClick={this.clearInput}>
										ล้างค่า
									</Button> */}
									<Button 
										type="primary" 
										id="btn-onsearch" 
										className="ml-2 color-white" 
										htmlType="submit" 
										disabled={preLoadSubmit}
									>
										ค้นหา
									</Button>
									{
										preLoadSubmit &&
										<Spin size="small" />
									}
								</Col>
							</Row>
						</Form>
						<Row gutter={16} type="flex" justify="left" align="top" className="box-color-white" >
							<Col xs={24} md={12} className="pt-2 mb-4">
								<strong className="color-red">
									รายการขอเบิก
								</strong>
							</Col>
							{/* <Col xs={24} md={12} className="mb-4" align="right">
								<Button type="primary btn-color-default color-white" htmlType="submit">
									EXPORT
								</Button>
							</Col> */}
							<Col xs={ 24 } md={24} align={"center"}>
								{
									// dataTalbe.length !== 0 &&
									<Table
										locale={{ emptyText: 'ไม่พบข้อมูลรายการ' }} 
										dataSource={dataTalbe} 
										columns={columns} 
										loading={loading}
										scroll={{ x:"max-content", y: '550px' }}
											// pagination={pagination}
										pagination={false}
										// onChange={this.paginationChange}
										// rowCount={dataTalbe.length}
									/>
									// ||
									// <p>ไม่มีข้อมูลรายการ</p>
								}
								
							</Col>
						</Row>
					</div>
				</div>
			</Container>
		)
	}
}

SearchForm.defaultProps = {
	autoFocus: false
}

SearchForm.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedSearchForm = Form.create()(SearchForm)

export default withApollo(WrappedSearchForm)